"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentServiceStub = void 0;
const faker_1 = __importDefault(require("faker"));
class PaymentServiceStub {
    async getPlanInfo(planName) {
        if (planName) {
            const pricePlanInfo = {
                id: `price_${faker_1.default.random.alphaNumeric()}`,
                productId: `product_${faker_1.default.random.alphaNumeric()}`,
                productName: faker_1.default.random.word(),
                recurringInterval: "month",
                recurringIntervalCount: 1,
                trialPeriodDays: faker_1.default.random.number(30),
                amount: faker_1.default.random.number(),
                type: "recurring",
            };
            return { status: true, message: "Plan info", payload: pricePlanInfo };
        }
        return { status: false, message: "Failed to get plan info", payload: null };
    }
    async getSubscriptionPlans() {
        const pricePlanInfo = {
            id: `price_${faker_1.default.random.alphaNumeric()}`,
            productId: `product_${faker_1.default.random.alphaNumeric()}`,
            productName: faker_1.default.random.word(),
            recurringInterval: "month",
            recurringIntervalCount: 1,
            trialPeriodDays: faker_1.default.random.number(30),
            amount: faker_1.default.random.number(),
            type: "recurring",
        };
        return { status: true, message: "Plan info", payload: [pricePlanInfo] };
    }
}
exports.PaymentServiceStub = PaymentServiceStub;
//# sourceMappingURL=PaymentServiceStub.js.map